export default {
  portrait: 'portrait',
  landscape: 'landscape',
};
